import { onBeforeUnmount, onMounted, useBlokkli } from "#imports";
export default function(name, cb) {
  const { broadcast } = useBlokkli();
  onMounted(() => {
    broadcast.on(name, cb);
  });
  onBeforeUnmount(() => {
    broadcast.off(name, cb);
  });
}
